import React from 'react';
import { styled } from '@mui/material/styles';

export const WarningIcon = (
  fillColour: string | React.CSSProperties['color'],
) => {
  return (
    <WarningIconRotateWrapper>
      <svg height='16' width='16' style={{ borderRadius: '2px' }}>
        <rect
          width='16'
          height='16'
          style={{
            fill: fillColour,
          }}
        />
      </svg>
    </WarningIconRotateWrapper>
  );
};

const WarningIconRotateWrapper = styled('div')`
  transform: rotate(45deg);
  height: 16px;
  width: 16px;
  margin-left: 4px;
  margin-right: 16px;
`;
